<script setup lang="ts">
import PerfectScrollbar from '../perfect-scrollbar/index.vue';
import HistoryTabItem from '@/components/tabs/HistoryTabItem.vue';
import { computed, ref, watch } from 'vue';
import useMatestoreStore from '@/store/matestoreStore';
import useGlobalStore from '@/store/globalStore';
import { useRoute } from 'vue-router';
import { useGlobalRouteStore } from '@/store/globalRouteStore';
import { TabItem } from '@/api/model/globalModel';
import TabManagePopover from '@/components/tabs/TabManagePopover.vue';
const psScrollRef = ref();
const tabsContainer = ref();
const matestoreStore = useMatestoreStore();
const globalStore = useGlobalStore();
const route = useRoute();
const globalRouteStore = useGlobalRouteStore();
const reachStart = ref(false);
const reachEnd = ref(false);

const props = defineProps<{ theme: 'v1' | 'v2' }>();

const notInitialPath = (tabItem: TabItem) => {
  const currentApp = matestoreStore.currentApp;
  const tabHash = tabItem?.fullPath?.split('#')[1];
  const currentAppInitialHash = currentApp?.initialHash?.replace(/^#/, '');
  console.log('currentAppInitialHash', currentAppInitialHash);
  console.log('tabHash', tabHash);

  return tabHash !== currentAppInitialHash;
};
const currentTabIndex = computed(() => {
  if (!matestoreStore.microRouteHistory) {
    return -1;
  }
  return matestoreStore.microRouteHistory.findIndex(
    (item) => item.fullPath === globalRouteStore.currentRoute?.fullPath
  );
});
watch(
  () => matestoreStore.microRouteHistory,
  (newVal, oldValue) => {
    setTimeout(() => {
      const index = currentTabIndex.value;
      if (index < 0) {
        return;
      }
      const el = document.getElementById(`mateHistoryTab${index}`);
      if (el) {
        el.scrollIntoView();
      }
    }, 100);
  }
);

const scrollToNext = () => {
  if (!psScrollRef.value?.psElRef) return;
  const psEl: Element = psScrollRef.value.psElRef;
  psEl.scrollTo(psEl.scrollLeft + 200, 0);
};

const scrollToPrev = () => {
  if (!psScrollRef.value?.psElRef) return;
  const psEl: Element = psScrollRef.value.psElRef;
  psEl.scrollTo(psEl.scrollLeft - 200, 0);
};
const handleScrolling = () => {
  reachEnd.value = false;
  reachStart.value = false;
};
</script>

<template>
  <div ref="tabsContainer" :class="{ 'history-tab-container': true }">
    <perfect-scrollbar
      ref="psScrollRef"
      :class="{
        'history-tab': true,
        'history-tab--theme-v2': props.theme === 'v2',
      }"
      :suppress-scroll-y="false"
      @x-reach-start="reachStart = true"
      @x-reach-end="reachEnd = true"
      @scroll-x="handleScrolling"
    >
      <history-tab-item
        v-for="(item, index) in matestoreStore.microRouteHistory"
        :key="index"
        :tab-index="index"
        :active="item.fullPath === globalRouteStore.currentRoute?.fullPath"
        :route="item"
        :name="item.title"
        :icon="item.icon"
        :closeable="notInitialPath(item)"
      />
    </perfect-scrollbar>
    <div class="history-tab-actions">
      <n-button
        size="small"
        icon="arrow_left"
        type="text"
        kind="neutral"
        :disabled="reachStart"
        @click="scrollToPrev"
      />
      <n-button
        size="small"
        icon="arrow_right"
        type="text"
        kind="neutral"
        :disabled="reachEnd"
        @click="scrollToNext"
      />
      <tab-manage-popover>
        <n-button
          size="small"
          type="text"
          kind="neutral"
          icon="ellipsis"
        ></n-button>
      </tab-manage-popover>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.history-tab-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 10;
  height: 38px;
  padding-right: 55px;
  overflow: hidden;
}
.history-tab {
  overflow: auto;
  display: flex;
  background: #f4f5f7;
  border-radius: 12px 0px 0px 0px;
  padding-left: 24px;
  width: 100%;
  padding-top: 0px;
  padding-right: 30px;
  &--theme-v2 {
    border-radius: 0;
  }
}
.history-tab-actions {
  position: absolute;
  right: 0;
  top: 0;
  height: 38px;
  padding: 9px 10px;
  padding-left: 0;
  background: #f4f5f7;
  &:before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -24px;
    z-index: 1;
    width: 24px;
    margin: auto;
    line-height: 1;
    background: linear-gradient(
      to right,
      rgba(244, 245, 246, 0) 0%,
      rgba(244, 245, 247, 0.7),
      rgb(244, 245, 247) 100%
    );
    content: '';
    pointer-events: none;
  }
}
</style>
